const DatasetToSunrunUtilityName = {
    'Arizona Public Service Co': 'APS',
    'Salt River Project': 'SRP',
    'Tucson Electric Power Co': 'TEP',
    'Alameda Municipal Power': 'Alameda Municipal Power',
    APU: 'APU',
    'Banning Electric Utility': 'Banning Electric Utility',
    'City of Burbank Water and Power': 'Burbank',
    'City of Colton - (CA)': 'Colton Electric Utility',
    'City of Glendale - (CA)': 'Glendale Water & Power',
    'Los Angeles Department of Water & Power': 'LADWP',
    'City of Lodi - (CA)': 'Lodi Electric Utility Department',
    'City of Palo Alto Utilities': 'City of Palo Alto Utilities',
    'City of Pasadena - (CA)': 'Pasadena',
    'City of Riverside - (CA)': 'Riverside Public Utilities',
    'City of Roseville - (CA)': 'Roseville Electric',
    'City of Moreno Valley - (CA)': 'Moreno Valley Electric Utility',
    'Modesto Irrigation District': 'Modesto Irrigation District',
    'Pacific Gas & Electric Co.': 'PG&E',
    'Southern California Edison Co': 'SCE',
    'San Diego Gas & Electric Co': 'SDG&E',
    'Silicon Valley Power': 'Silicon Valley Power',
    'Sacramento Municipal Util Dist': 'SMUD',
    'Turlock Irrigation District': 'Turlock Irrigation District',
    IREA: 'IREA',
    'United Power, Inc': 'United Power',
    'Xcel Energy': 'XCEL',
    'City of Colorado Springs - (CO)': 'Colorado Springs Utilities',
    'City of Fort Collins - (CO)': 'Fort Collins Utilities',
    'Mountain View Elec Assn, Inc': 'Mountain View Electric Association',
    ALL: 'ALL',
    'PECO Energy Co': 'PEPCO',
    'Duke Energy': 'Duke Energy',
    'Orlando Utilities Comm': 'OUC',
    'TECO Energy': 'TECO Energy',
    'Gulf Power Co': 'Gulf Power Co',
    'Florida Power & Light Co': 'FPL',
    'Withlacoochee River Elec Coop': 'Withlacoochee River Elec Coop',
    'Sumter Electric Coop, Inc': 'Sumter Electric Coop',
    'Kissimmee Utility Authority': 'Kissimmee Utilities Authority',
    'Peace River Electric Coop, Inc': 'Peace River Electric Coop',
    'Hawaiian Electric Co Inc': 'HECO',
    HELCO: 'HELCO',
    MECO: 'MECO',
    'Commonwealth Edison Co': 'ComEd',
    'City of Naperville - (IL)': 'Naperville',
    'Ameren Illinois Company': 'Ameren',
    'NineStar Connect': 'Nine Star Electric',
    Eversource: 'Eversource',
    WMECO: 'WMECO',
    'National Grid': 'National Grid',
    UNITIL: 'UNITIL',
    'BG&E': 'BG&E',
    'Choptank Electric Cooperative, Inc': 'Choptank Electric',
    'The Potomac Edison Company': 'Potomac Edison',
    SMECO: 'SMECO',
    'Central Maine Power': 'Central Maine Power',
    ACE: 'ACE',
    'JCP&L': 'JCP&L',
    'PSE&G': 'PSE&G',
    'Rockland Electric': 'Rockland Electric',
    Vineland: 'Vineland',
    'Public Service Co of NM': 'PNM',
    'NV Energy South': 'NV Energy South',
    'Central Hudson Gas & Elec Corp': 'Central Hudson',
    'Consolidated Edison Co-NY Inc': 'ConEdison',
    'Orange & Rockland Utils Inc': 'O&R',
    'Long Island Power Authority': 'PSEGLI',
    'New York State Elec & Gas Corp': 'NYSE&G',
    'Met-Ed': 'Met-Ed',
    'PPL Electric Utilities Corp': 'PPL',
    Penelec: 'Penelec',
    'Laurens Electric Coop, Inc': 'Laurens Electric',
    'SCE&G': 'SCE&G',
    'Berkeley Electric Coop Inc': 'Berkeley Electric Coop',
    'Blue Ridge Electric Coop Inc - (NC)': 'Blue Ridge Electric Coop',
    'Centerpoint Energy': 'Centerpoint Energy',
    Oncor: 'Oncor',
    TNMP: 'TNMP',
    Entergy: 'Entergy',
    'Austin Energy': 'Austin Energy',
    'Pedernales Electric Coop, Inc': 'Pedernales',
    Coserv: 'Coserv',
    'CPS Energy': 'CPS Energy',
    'Denton Municipal Electric': 'Denton Municipal Electric',
    'Tri-County Electric Coop, Inc': 'Tri County Electric Coop',
    'Bluebonnet Electric Coop, Inc': 'Bluebonnet Electric Coop',
    'Golden Valley Elec Assn Inc': 'GVEC',
    'Lehi City Corporation': 'Lehi',
    'Rocky Mountain Power': 'Rocky Mountain Power',
    'Burlington Electric Department': 'Burlington Electric Department',
    'Green Mountain Power': 'Green Mountain Power',
    'Vermont Electric Cooperative': 'Vermont Electric Cooperative',
    'We Energies': 'We Energies',
    'Dominion Virginia Power': 'Dominion Virginia Power',
    'Northern Virginia Elec Coop': 'NOVEC',
    'Rappahannock Electric Coop': 'VA Rappahannock Electric Coop',
} as const;

export type DatasetUtilityName = keyof typeof DatasetToSunrunUtilityName;

export type SunrunUtilityName =
    (typeof DatasetToSunrunUtilityName)[DatasetUtilityName];

const SunrunToDatasetUtilityName = Object.fromEntries(
    Object.entries(DatasetToSunrunUtilityName).map(([k, v]) => [v, k])
) as Record<SunrunUtilityName, DatasetUtilityName>;

export function getSunrunUtilityName(utilityName: string): string {
    if (!utilityName) return utilityName;

    return (
        DatasetToSunrunUtilityName[utilityName as DatasetUtilityName] ??
        utilityName
    );
}

export function getDatasetUtilityName(utilityName: string): string {
    if (!utilityName) return utilityName;

    return (
        SunrunToDatasetUtilityName[utilityName as SunrunUtilityName] ??
        utilityName
    );
}
